import { atomWithReset } from "jotai/utils";

export const displayEngineerPromoModalAtom = atomWithReset(false);
displayEngineerPromoModalAtom.debugLabel = "Display Engineer Promo Modal";
